export default __webpack_public_path__ + "static/media/hook.6950e9f9.png";